import moneyIcon from '../../icons/money.svg'
import switchOff from '../../icons/switch-off.svg'
import switchOn from '../../icons/switch-on.svg'
import closeIcon from "../../icons/close.svg";
import removeBigIcon from "../../icons/remove-big.svg";

const AuthorizationDialog = ({ setSavePayment }) => {
    return <div>
        <div style={{ background: "#0000004D", position: "fixed", top: 0, left: 0, right: 0, bottom: 0 }}></div>
        <div style={{
            background: "white",
            position: "fixed",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            left: 0,
            right: 0,
            bottom: 0,
            height: 284,
            zIndex: 9999
        }}>
            <button onClick={() => setSavePayment(false)}
                style={{
                    position: "absolute",
                    right: 16,
                    top: 16,
                    padding: 8,
                    border: 0,
                    background: "#F1F1F1",
                    borderRadius: 8
                }}>
                <img src={closeIcon} style={{ display: "block" }} />
            </button>
            <div style={{ textAlign: "center", marginTop: 42 }}>
                <img src={removeBigIcon} />
                <div style={{ fontSize: 22, fontWeight: 600, marginTop: 22, letterSpacing: "-0.018em" }}>Вы не
                    авторизованы
                </div>
                <div>Для сохранения способа оплаты нужно авторизоваться в сервисе 2ГИС</div>
                <div style={{
                    display: "flex",
                    gap: 8,
                    paddingLeft: 16,
                    paddingRight: 16,
                    justifyContent: "center",
                    marginTop: 16
                }}>
                    <a href={"dgis://2gis.ru/profile"}
                        style={{ display: "block", textDecoration: "none", width: "100%" }}>
                        <div style={{
                            fontSize: 16,
                            fontWeight: 600,
                            border: 0,
                            borderRadius: 10,
                            width: "100%",
                            height: 48,
                            lineHeight: "48px",
                            color: "white",
                            background: "#1DB93C"
                        }}>Авторизоваться
                        </div>
                    </a>
                </div>
            </div>

        </div>
    </div>
}

const AutoPayment = ({ savePayment, setSavePayment, verified }) => {
    return <>
        {!verified && savePayment && <AuthorizationDialog setSavePayment={setSavePayment} />}

        <div style={{ background: "white", borderRadius: 16, paddingLeft: 16, paddingRight: 16 }}>
            <div style={{ display: "flex", paddingTop: 10, justifyContent: "space-between", paddingBottom: 12 }}>
                <div>
                    <img src={moneyIcon}
                        style={{ paddingLeft: 8, paddingTop: 8, display: "block", height: 24, width: 24 }} />
                </div>
                <div style={{ paddingLeft: 16, width: "100%" }}>
                    <div>Банковская карта</div>
                    <div style={{
                        color: "#898989",
                        fontSize: 14
                    }}>Запомнить для следующих покупок
                    </div>
                </div>
                <div style={{ color: "#1BA136", paddingRight: 8 }} onClick={() => setSavePayment(!savePayment)}>
                    {savePayment ? <img style={{ display: "block", height: 36, width: 54 }} src={switchOn} /> :
                        <img style={{ display: "block", height: 36, width: 54 }} src={switchOff} />}
                </div>
            </div>
        </div>
    </>
}

export default AutoPayment